import type { CountryCode } from '@klear/constants/countries'
import type { DocumentReviewUpdateInput } from '@/app/document-review/use-document-review'

export type PartyPickerKind = 'customer' | 'supplier'

export type PartyPick =
  | { kind: 'existing'; id: number; name: string }
  | { kind: 'create'; name: string; countryCode: CountryCode }

type ReviewEdit = DocumentReviewUpdateInput['data']
type PartyRefEdit = NonNullable<NonNullable<ReviewEdit['proposals']>[number]['supplier']>

function partyRefEdit(pick: PartyPick): PartyRefEdit {
  if (pick.kind === 'existing') return { kind: 'existing', id: pick.id }
  return { kind: 'create', party: { name: pick.name, countryCode: pick.countryCode } }
}

export function supplierEdit(ordinal: number, pick: PartyPick): ReviewEdit {
  return { proposals: [{ ordinal, supplier: partyRefEdit(pick) }] }
}

export function existingOrderEdit(orderId: number): ReviewEdit {
  return { order: { kind: 'existing', orderId } }
}

export function newOrderEdit(customer: PartyPick): ReviewEdit {
  return { order: { kind: 'create', customer: partyRefEdit(customer) } }
}
